<template>
  <layout-default-app-bar :back-to="false">
    <div class="d-flex align-center custom-header">
      <v-btn icon @click="voltar" class="mr-2">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <span class="pl-2 text-h6">{{ tituloAppBar }}</span>
    </div>
  </layout-default-app-bar>
</template>

<script>
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      tituloAppBar: 'Cadastro Equipamento' 
    };
  },

  methods: {
    voltar() {
      this.$root.$emit('appbar-solicita-cancelamento');
    },

    atualizarTitulo(novoTitulo) {
      this.tituloAppBar = novoTitulo;
    }
  },

  created() {
    this.$root.$on('appbar-alterar-titulo', this.atualizarTitulo);
  },

  beforeDestroy() {
    this.$root.$off('appbar-alterar-titulo', this.atualizarTitulo);
  }
};
</script>

<style scoped>

::v-deep .v-app-bar__nav-icon {
  display: none !important;
}

::v-deep button.v-app-bar__nav-icon {
  display: none !important;
}

.custom-header {
  margin-left: -30px;
}

</style>